<div class="min-h-full">
    <div class="sticky left-0 top-0 z-50 bg-purple-200 flex items-center gap-2">
        <img
            class="size-20"
            [src]="urls().logoFile"
            alt="" />
        <span class="text-5xl font-bold">{{ _offerStore.offerId() }} - {{ generalForm.value.title }}</span>
    </div>
    <mat-accordion multi>
        <mat-expansion-panel expanded>
            <mat-expansion-panel-header>
                <mat-panel-title>OfferID: {{_offerStore.offerId()}}</mat-panel-title>
            </mat-expansion-panel-header>
            <ng-template matExpansionPanelContent>
                <form
                    class="flex flex-col"
                    [formGroup]="generalForm">
                    <mat-form-field>
                        <mat-label>Title</mat-label>
                        <input
                            matInput
                            formControlName="title" />
                    </mat-form-field>
                    <mat-form-field class="mb-4">
                        <mat-label>Short description</mat-label>
                        <textarea
                            matInput
                            formControlName="shortDescription"
                            cdkTextareaAutosize
                            cdkAutosizeMinRows="1"
                            maxlength="30"></textarea>
                        <mat-hint align="end">
                            {{ generalForm.controls.shortDescription.value?.length ?? 0 }} / 30
                        </mat-hint>
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Description</mat-label>
                        <textarea
                            matInput
                            formControlName="description"
                            cdkTextareaAutosize
                            cdkAutosizeMinRows="1"></textarea>
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Goals</mat-label>
                        <mat-select
                            formControlName="goalType"
                            multiple>
                            @for (item of CampaignOfferGoalType | appEnumKeyValue; track $index) {
                                <mat-option [value]="item.value">{{ item.key }}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    <mat-label class="mb-0.5 text-base font-medium">Logo</mat-label>
                    <div class="flex items-center gap-2">
                        <img
                        class="size-20 mr-2"
                        [src]="urls().logoFile"
                        alt="" />
                    <input
                        class="mb-5"
                        type="file"
                        accept="image/*"
                        formControlName="logoFile"
                        (change)="onFileUploaded($event, 'logoFile')" />
                    </div>
                    <mat-label class="mb-0.5 text-base font-medium">Editor choice banner</mat-label>
                    <div class="flex items-center gap-2">
                        <img
                        class="w-20 mr-2"
                        [src]="urls().editorChoiceBannerFile"
                        alt="" />
                    <input
                        class="mb-5"
                        type="file"
                        accept="image/*"
                        formControlName="editorChoiceBannerFile"
                        (change)="onFileUploaded($event, 'editorChoiceBannerFile')" />
                    </div>
                    <mat-label class="mb-0.5 text-base font-medium">Small banner</mat-label>
                    <div class="flex items-center gap-2">
                        <img
                        class="w-20 mr-2"
                        [src]="urls().smallBannerFile"
                        alt="" />
                    <input
                        type="file"
                        accept="image/*"
                        formControlName="smallBannerFile"
                        (change)="onFileUploaded($event, 'smallBannerFile')" />
                    </div>
                </form>
            </ng-template>
        </mat-expansion-panel>
        <mat-expansion-panel expanded>
            <mat-expansion-panel-header>
                <mat-panel-title>App info</mat-panel-title>
            </mat-expansion-panel-header>
            <ng-template matExpansionPanelContent>
                <form
                    class="flex flex-col"
                    [formGroup]="appInfoForm">
                    <mat-form-field>
                        <mat-label>Source</mat-label>
                        <mat-select formControlName="sourceType">
                            @for (item of OfferSourceType | appEnumKeyValue; track $index) {
                                <mat-option [value]="item.value">{{ item.key }}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>App name</mat-label>
                        <input
                            matInput
                            formControlName="appName" />
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>MMP provider</mat-label>
                        <mat-select formControlName="mmpProvider">
                            @for (item of MMPProviderType | appEnumKeyValue; track $index) {
                                <mat-option [value]="item.value">{{ item.key }}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>App id</mat-label>
                        <input
                            matInput
                            formControlName="appId" />
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Bundle id</mat-label>
                        <input
                            matInput
                            formControlName="bundleId" />
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Secure postback code</mat-label>
                        <input
                            matInput
                            formControlName="securePostbackCode" />
                    </mat-form-field>
                    <mat-form-field class="mb-3">
                        <mat-label>Advertiser tracking url</mat-label>
                        <input
                            matInput
                            formControlName="advertiserTrackingUrl" />
                    </mat-form-field>
    
                    <ng-template #macroTooltip>
                        <app-offer-advertiser-url-params-tooltip></app-offer-advertiser-url-params-tooltip>
                    </ng-template>
                    <mat-form-field>
                        <mat-label>User tracking url</mat-label>
                        <input
                            matInput
                            formControlName="userTrackingUrl" />
                        <mat-hint
                            class="cursor-pointer !text-blue-700"
                            [tp]="macroTooltip"
                            tpVariation="popper"
                            tpPlacement="bottom-start">
                            Show macro
                        </mat-hint>
                    </mat-form-field>
                </form>
            </ng-template>
        </mat-expansion-panel>
        <mat-expansion-panel>
            <mat-expansion-panel-header>
                <mat-panel-title>Billing</mat-panel-title>
            </mat-expansion-panel-header>
            <ng-template matExpansionPanelContent>
                <form
                    class="flex flex-col"
                    [formGroup]="billingForm">
                    <mat-form-field>
                        <mat-label>Price</mat-label>
                        <input
                            matInput
                            type="number"
                            nxNoScroll
                            formControlName="price" />
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Billing type</mat-label>
                        <mat-select formControlName="billingType">
                            @for (item of BillingType | appEnumKeyValue; track $index) {
                                <mat-option [value]="item.value">{{ item.key }}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Installs daily cap</mat-label>
                        <input
                            type="number"
                            noScroll
                            matInput
                            formControlName="installsDailyCap" />
                    </mat-form-field>
                </form>
            </ng-template>
        </mat-expansion-panel>
        <mat-expansion-panel expanded>
            <mat-expansion-panel-header>
                <mat-panel-title>Targeting</mat-panel-title>
            </mat-expansion-panel-header>
            <ng-template matExpansionPanelContent>
                <form
                    class="flex flex-col"
                    [formGroup]="targetingForm">
                    <mat-form-field>
                        <mat-label>Offer type</mat-label>
                        <mat-select
                            formControlName="offerType"
                            multiple>
                            @for (item of OfferType | appEnumKeyValue; track $index) {
                                <mat-option [value]="item.value">{{ item.key }}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Placement</mat-label>
                        <mat-select formControlName="offerPlacement">
                            @for (item of OfferPlacement | appEnumKeyValue; track $index) {
                                <mat-option [value]="item.value">{{ item.key }}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Order in placement</mat-label>
                        <input
                            matInput
                            type="number"
                            noScroll
                            formControlName="orderInPlacement" />
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Platform</mat-label>
                        <mat-select formControlName="platform">
                            <mat-option [value]="Platform.Android">Android</mat-option>
                            <mat-option [value]="Platform.IOS">iOS</mat-option>
                            <mat-option [value]="Platform.Web">Web</mat-option>
                            <mat-option [value]="Platform.None">None</mat-option>
                            <mat-option [value]="Platform.Undefined">Undefined</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Target group</mat-label>
                        <mat-select formControlName="targetGroup">
                            <mat-option [value]="null"></mat-option>
                            @for (item of targetGroupsStore.entities(); track $index) {
                                <mat-option [value]="item.id">{{ item.name }}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Game categories</mat-label>
                        <mat-select
                            formControlName="gameCategories"
                            multiple>
                            @for (item of gameCategoriesStore.entities(); track $index) {
                                <mat-option [value]="item.id">{{ item.name }}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Country codes</mat-label>
                        <mat-chip-grid
                            #countriesGrid
                            [formControl]="targetingForm.controls.countryCodes">
                            @for (code of targetingForm.controls.countryCodes.value; track code) {
                                <mat-chip-row
                                    (removed)="removeChip(code, targetingForm.controls.countryCodes)">
                                    {{ code }}
                                    <button matChipRemove>
                                        <mat-icon>cancel</mat-icon>
                                    </button>
                                </mat-chip-row>
                            }
                        </mat-chip-grid>
                        <input
                            [matChipInputFor]="countriesGrid"
                            (matChipInputTokenEnd)="
                                addChip($event, targetingForm.controls.countryCodes)
                            " />
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Order</mat-label>
                        <input
                            matInput
                            type="number"
                            noScroll
                            formControlName="order" />
                    </mat-form-field>
                </form>
            </ng-template>
        </mat-expansion-panel>
        <mat-expansion-panel expanded>
            <mat-expansion-panel-header>
                <mat-panel-title>Duration</mat-panel-title>
            </mat-expansion-panel-header>
            <ng-template matExpansionPanelContent>
                <form
                    class="flex flex-col"
                    [formGroup]="durationForm">                
                    <mat-form-field>
                        <mat-label>Duration</mat-label>
                        <input
                            matInput
                            formControlName="duration" />
                        <mat-hint>d.hh:mm</mat-hint>
                    </mat-form-field>
                    <mat-expansion-panel-header>
                        <mat-panel-title>Start date (optional)</mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="flex items-center gap-x-2">
                        <mat-form-field>
                            <mat-label>Choose a date</mat-label>
                            <input
                                matInput
                                [matDatepicker]="pickerStart"
                                formControlName="startDate" />
                            <mat-datepicker-toggle
                                matIconPrefix
                                [for]="pickerStart"></mat-datepicker-toggle>
                            <mat-datepicker #pickerStart></mat-datepicker>
                        </mat-form-field>
                        <mat-form-field>
                            <mat-label>Hours</mat-label>
                            <input
                                matInput
                                type="number"
                                noScroll
                                formControlName="startDateHours" />
                        </mat-form-field>
                        <mat-form-field>
                            <mat-label>Minutes</mat-label>
                            <input
                                matInput
                                type="number"
                                noScroll
                                formControlName="startDateMinutes" />
                        </mat-form-field>
                    </div>
                    <mat-expansion-panel-header>
                        <mat-panel-title>End date (optional)</mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="flex items-center gap-x-2">
                        <mat-form-field>
                            <mat-label>Choose a date</mat-label>
                            <input
                                matInput
                                [matDatepicker]="pickerEnd"
                                formControlName="endDate" />
                            <mat-datepicker-toggle
                                matIconPrefix
                                [for]="pickerEnd"></mat-datepicker-toggle>
                            <mat-datepicker #pickerEnd></mat-datepicker>
                        </mat-form-field>
                        <mat-form-field>
                            <mat-label>Hours</mat-label>
                            <input
                                matInput
                                type="number"
                                noScroll
                                formControlName="endDateHours" />
                        </mat-form-field>
                        <mat-form-field>
                            <mat-label>Minutes</mat-label>
                            <input
                                matInput
                                type="number"
                                noScroll
                                formControlName="endDateMinutes" />
                        </mat-form-field>
                    </div>
                </form>
            </ng-template>
        </mat-expansion-panel>
        <mat-expansion-panel>
            <mat-expansion-panel-header>
                <mat-panel-title>Achievement</mat-panel-title>
            </mat-expansion-panel-header>
            <ng-template matExpansionPanelContent>
                <form
                    class="flex flex-col"
                    [formGroup]="achievementForm">
                    <mat-form-field>
                        <mat-label>Select achievement</mat-label>
                        <mat-select formControlName="achievementId">
                            <mat-option [value]="null">None</mat-option>
                            @for (achievement of achievements(); track $index) {
                                <mat-option [value]="achievement.id">
                                    {{ achievement.id }} - {{ achievement.title }}
                                </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </form>
            </ng-template>
        </mat-expansion-panel>
        <mat-expansion-panel>
            <mat-expansion-panel-header>
                <mat-panel-title>Analytics</mat-panel-title>
            </mat-expansion-panel-header>
            <ng-template matExpansionPanelContent>
                <form
                    class="flex flex-col gap-y-2"
                    [formGroup]="analyticsForm">
                    <mat-form-field>
                        <mat-label>Progression</mat-label>
                        <mat-select formControlName="progressionType">
                            @for (keyValue of OfferProgressionType | appEnumKeyValue; track $index) {
                                <mat-option [value]="keyValue.value">{{ keyValue.key }}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Genres</mat-label>
                        <mat-select
                            formControlName="genres"
                            multiple>
                            @for (genre of offerGenresStore.entities(); track $index) {
                                <mat-option [value]="genre.name">
                                    {{ genre.name }}
                                </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>SubGenres</mat-label>
                        <mat-select
                            formControlName="subGenres"
                            multiple>
                            @for (subGenre of subGenres(); track $index) {
                                <mat-option [value]="subGenre.name">
                                    {{ subGenre.name }}
                                </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </form>
            </ng-template>
        </mat-expansion-panel>
        <mat-expansion-panel>
            <mat-expansion-panel-header>
                <mat-panel-title>A/B test</mat-panel-title>
            </mat-expansion-panel-header>
            <ng-template matExpansionPanelContent>
                <form
                    class="flex flex-col gap-y-2"
                    [formGroup]="abTestsForm">
                    <mat-form-field>
                        <mat-label>Select groups</mat-label>
                        <mat-select
                            formControlName="abTestGroupIds"
                            multiple>
                            @for (abTest of abTests(); track $index) {
                                @for (group of abTest.groups; track $index) {
                                    <mat-option [value]="group.id">
                                        {{ abTest.name }} - {{ group.name }}
                                    </mat-option>
                                }
                            }
                        </mat-select>
                    </mat-form-field>
                    <mat-checkbox
                        color="primary"
                        formControlName="forUsersWithoutAbGroup">
                        For users without group
                    </mat-checkbox>
                </form>
            </ng-template>
        </mat-expansion-panel>
        <form [formGroup]="miscForm">
            <mat-checkbox
                class="mb-5"
                color="primary"
                formControlName="isActive">
                Active
            </mat-checkbox>
        </form>
        <button
            class="ml-2.5"
            mat-flat-button
            color="primary"
            (click)="updateOffer()"
            [disabled]="hasInvalidForm()">
            Save
        </button>
    </mat-accordion>
</div>

